var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lo"},[_c('div',{staticClass:"lo__modal"},[_c('ClipLoader',{attrs:{"loading":true,"color":"#0774E7"}}),_c('p',{domProps:{"textContent":_vm._s(_vm.$ml.get(_vm.text))}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }